var exports = {
  "XD": "DebugPopover__xOTNAT",
  "kA": "DebugTextarea__Cm0sMW",
  "pu": "DebugEmptyDescription__ttW7Sh",
  "j0": "DebugFooter__ftV2AF",
  "xR": "DebugActions__52wgBP",
};

module.exports = exports;
